module.exports = __webpack_public_path__ + "static/media/plant-highlight.7857dcbf.svg";